function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import tokens from '@veneer/tokens';
import highContrastMediaQuery from '../../utils/high_contrast_media_query';
import typography from '../../utils/typography';
import { useTheme } from '@veneer/theme';
var useContainerStyle = _ref => {
  var {
    isCompact
  } = _ref;
  var theme = useTheme();
  return React.useMemo(() => {
    return {
      container: _objectSpread({
        display: 'flex',
        flexDirection: 'column',
        marginTop: !isCompact ? theme.orbitalTwo : undefined,
        minWidth: '125px',
        padding: isCompact ? theme.layout.size2 : undefined
      }, highContrastMediaQuery(theme)),
      subContainer: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: tokens.layout.size8
      }
    };
  }, [isCompact, theme]);
};
var iconStyle = theme => ({
  height: '100%',
  marginRight: tokens.layout.size0,
  maxHeight: theme.passwordRequirements.iconWidthHeight,
  maxWidth: theme.passwordRequirements.iconWidthHeight,
  padding: 0,
  paddingTop: theme.passwordRequirements.iconPadding,
  width: '100%'
});
var useItemStyle = () => {
  var theme = useTheme();
  return React.useMemo(() => {
    return {
      bullet: {
        backgroundColor: theme.palette.foreground.disabled,
        borderRadius: theme.borderRadius2,
        height: tokens.layout.size2,
        margin: theme.passwordRequirements.bulletMargin,
        maxWidth: tokens.layout.size2,
        width: '100%'
      },
      iconCheck: _objectSpread({
        fill: theme.palette.positive.default
      }, iconStyle(theme)),
      iconMinus: _objectSpread({
        fill: theme.palette.negative.default
      }, iconStyle(theme)),
      item: {
        alignItems: 'flex-start',
        display: 'flex',
        marginTop: theme.passwordRequirements.itemMargin,
        marginBottom: theme.passwordRequirements.itemMargin
      },
      text: _objectSpread({
        alignSelf: 'center',
        color: theme.palette.foreground.default
      }, typography(theme).caption)
    };
  }, [theme]);
};
export { useContainerStyle, useItemStyle };